import styles from '../../styles';

export default function(state) {
  if (typeof state === 'undefined') {
    return styles;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/styles/index.js